import fetch from 'isomorphic-unfetch';

const VERSION = '8';
const isBrowser = typeof window !== 'undefined' && window != null && typeof window.document !== 'undefined';
class Api {
  constructor(opts) {
    var _opts$host;

    this.opts = opts;
    this.host = (_opts$host = opts.host) != null ? _opts$host : 'https://codegen.plasmic.app';
  }

  async fetchLoaderData(projectIds, opts) {
    const {
      platform,
      preview
    } = opts;
    const query = new URLSearchParams([['platform', platform != null ? platform : 'react'], ...projectIds.map(projectId => ['projectId', projectId]), ...(opts.browserOnly ? [['browserOnly', 'true']] : [])]).toString();
    const url = `${this.host}/api/v1/loader/code/${preview ? 'preview' : 'published'}?${query}`;
    const resp = await fetch(url, {
      method: 'GET',
      headers: this.makeGetHeaders()
    });

    if (resp.status >= 400) {
      var _error$error$message, _error$error;

      const error = await resp.json();
      throw new Error((_error$error$message = error == null ? void 0 : (_error$error = error.error) == null ? void 0 : _error$error.message) != null ? _error$error$message : resp.statusText);
    }

    const json = await resp.json();
    return json;
  }

  async fetchHtmlData(opts) {
    const {
      projectId,
      component,
      embedHydrate,
      hydrate
    } = opts;
    const query = new URLSearchParams([['projectId', projectId], ['component', component], ['embedHydrate', embedHydrate ? '1' : '0'], ['hydrate', hydrate ? '1' : '0']]).toString();
    const resp = await fetch(`${this.host}/api/v1/loader/html?${query}`, {
      method: 'GET',
      headers: this.makeGetHeaders()
    });
    const json = await resp.json();
    return json;
  }

  makeGetHeaders() {
    return {
      'x-plasmic-loader-version': VERSION,
      ...this.makeAuthHeaders()
    };
  } // @ts-ignore


  makePostHeaders() {
    return {
      'x-plasmic-loader-version': VERSION,
      'Content-Type': 'application/json',
      ...this.makeAuthHeaders()
    };
  }

  makeAuthHeaders() {
    const tokens = this.opts.projects.map(p => `${p.id}:${p.token}`).join(',');
    return {
      'x-plasmic-api-project-tokens': tokens
    };
  }

}

class PlasmicModulesFetcher {
  constructor(opts) {
    this.opts = opts;
    this.curFetch = undefined;
    this.api = new Api({
      projects: opts.projects,
      host: opts.host
    });
  }

  async fetchAllData() {
    if (this.opts.cache) {
      const cachedData = await this.opts.cache.get();

      if (cachedData) {
        return cachedData;
      }
    }

    if (this.curFetch) {
      return await this.curFetch;
    }

    console.debug('Plasmic: doing a fresh fetch...');
    this.curFetch = this.doFetch();
    const data = await this.curFetch;
    this.curFetch = undefined;
    return data;
  }

  async doFetch() {
    const data = await this.api.fetchLoaderData(this.opts.projects.map(p => p.version && !this.opts.preview ? `${p.id}@${p.version}` : p.id), {
      platform: this.opts.platform,
      preview: this.opts.preview,
      browserOnly: isBrowser
    });

    if (this.opts.cache) {
      await this.opts.cache.set(data);
    }

    console.debug(`Plasmic: fetched designs for ${data.projects.map(p => `"${p.name}" (${p.id}@${p.version})`).join(', ')}`);
    return data;
  }

}

export { Api, PlasmicModulesFetcher };
//# sourceMappingURL=loader-fetcher.esm.js.map
